import React, { PropsWithChildren } from 'react';

import styles from './InputContainer.module.scss';

interface FormContainerProps {}

const InputContainer: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.formContainer}>{children}</div>;
};

export default InputContainer;
